import { Component, OnInit } from "@angular/core";
import { SlimLoadingBarService } from "ng2-slim-loading-bar";
import { ProjectsService } from "../services/projects/projects.service";
import { ErrorHandlerService } from "../services/shared/error-handler.service";
import { CeoReportsService } from "../services/ceo-reports/ceo-reports.service";
import { removeNullishFieldsParams } from "../shared/object_helpers";
import { FinancialReportsService } from "../services/financial-reports/financial-reports.service";

@Component({
  selector: "app-ceo-reports",
  templateUrl: "./ceo-reports.component.html",
  styleUrls: ["./ceo-reports.component.css"],
})
export class CeoReportsComponent implements OnInit {
  isLoading = false;

  view = "sold_inventorty";
  page = 1;
  paginate;

  views_conf = {
    filters: false,
    charts: false,
  };

  reports: any = {
    sold_inventorty: {
      data: [],
      total: {},
    },
    avaliable_inventorty: {
      data: [],
      total: {},
    },
    dues_payment_with_sharing: {
      data: [],
      total: {},
    },
    dues_inventorty: {
      data: [],
      total: {},
    },
    not_avaliable_inventorty: {
      data: [],
      total: {},
    },
    monthly_payments_analysis: {},
    monthly_payments_analysis_total: null,
    partner_monthly_payments_analysis: {},
    partner_monthly_payments_analysis_total: null,
  };

  filter_form: any = {};
  filter_schema: any = {};

  filter_dependencies = {
    projects: [],
    unitTypes: [],
    banks: [],
    years: Array(50)
      .fill("")
      .map((v, idx) => new Date().getUTCFullYear() - idx + 25),
    deal_statuses: ["all", "contracted", "pending"],
    project_types: ["Residential", "Commercial"],
    payment_types: ["fully-collected", "pending"],
  };
  downloading_export: any = false;
  monthsArray = Array.from({ length: 13 }, (_, i) => i);

  constructor(
    private projectService: ProjectsService,
    private financialReportsService: FinancialReportsService,
    private errorHandlerService: ErrorHandlerService,
    private ceoReportsService: CeoReportsService,
    private slimLoadingBarService: SlimLoadingBarService,
  ) {}

  ngOnInit() {
    this.setView(this.view);
    this.getProjects();
  }

  getProjects(params: any = {}) {
    this.projectService.getProjects(params).subscribe((res: any) => {
      this.filter_dependencies.projects = res.data;
    });
  }

  setView(tab: string) {
    this.view = tab;
    this.filter_form = {};
    this.views_conf.filters = false;
    this.views_conf.charts = null;
    switch (tab) {
      case "sold_inventorty": {
        this.filter_schema = {
          filter_project_id: 1,
          filter_date_from: 1,
          filter_date_to: 1,
        };
        this.getProjects();
        break;
      }
      case "avaliable_inventorty": {
        this.filter_schema = {
          filter_project_id: 1,
        };
        this.getProjects();
        break;
      }
      case "dues_payment_with_sharing": {
        this.filter_schema = {
          filter_project_id: 1,
          filter_date_from: 1,
          filter_date_to: 1,
        };
        this.getProjects();
        break;
      }
      case "dues_inventorty": {
        this.filter_schema = {
          filter_project_id: 1,
          filter_date_from: 1,
          filter_date_to: 1,
        };
        this.getProjects();
        break;
      }
      case "not_avaliable_inventorty": {
        this.filter_schema = {
          filter_project_id: 1,
        };
        this.getProjects();
        break;
      }
      case "monthly_payments_analysis": {
        this.filter_schema = {
          filter_project_id: 1,
          filter_date_from: 1,
          filter_date_to: 1,
        };
        this.getProjects({ only_has_partner: true });
        break;
      }
      case "partner_monthly_payments_analysis": {
        this.filter_schema = {
          filter_project_id: 1,
          filter_date_from: 1,
          filter_date_to: 1,
        };
        this.getProjects();
        break;
      }
    }

    this.getData();
  }

  getData() {
    this.page = 1;
    switch (this.view) {
      case "sold_inventorty": {
        this.getSoldInventortyReport();
        break;
      }
      case "avaliable_inventorty": {
        this.getAvaliableInventortyReport();
        break;
      }
      case "dues_payment_with_sharing": {
        this.getDuesPaymentWithSharingReport();
        break;
      }
      case "dues_inventorty": {
        this.getDuesInventoryReport();
        break;
      }
      case "not_avaliable_inventorty": {
        this.getNotAvaliableInventortyReport();
        break;
      }
      case "monthly_payments_analysis": {
        this.getMonthlyPaymentsReport();
        break;
      }
      case "partner_monthly_payments_analysis": {
        this.getPartnerMonthlyPaymentsReport();
        break;
      }
    }
  }

  getSoldInventortyReport(is_export?) {
    this.slimLoadingBarService.start();
    if (is_export) {
      this.downloading_export = 1;
      this.filter_form.is_export = 1;
    } else {
      this.enableLoading();
    }
    this.ceoReportsService.getSoldInventortyReport(this.filter_form).subscribe(
      (res: any) => {
        if (is_export) {
          window.open(res.url);
          this.downloading_export = false;
          this.filter_form.is_export = false;
          delete this.filter_form.type;
        } else {
          this.reports.sold_inventorty.data = res.data;
          this.reports.sold_inventorty.total = res.total;
        }
      },
      (err) => {
        this.downloading_export = false;
        this.errorHandlerService.handleErorr(err);
      },
      () => {
        if (this.view === "sold_inventorty") {
          this.slimLoadingBarService.complete();
          this.disableLoading();
        }
      },
    );
  }

  getAvaliableInventortyReport(is_export?) {
    this.slimLoadingBarService.start();
    if (is_export) {
      this.downloading_export = 1;
      this.filter_form.is_export = 1;
    } else {
      this.enableLoading();
    }
    this.ceoReportsService
      .getAvaliableInventortyReport(this.filter_form)
      .subscribe(
        (res: any) => {
          if (is_export) {
            window.open(res.url);
            this.downloading_export = false;
            this.filter_form.is_export = false;
            delete this.filter_form.type;
          } else {
            this.reports.avaliable_inventorty.data = res.data;
            this.reports.avaliable_inventorty.total = res.total;
          }
        },
        (err) => {
          this.downloading_export = false;
          this.errorHandlerService.handleErorr(err);
        },
        () => {
          this.slimLoadingBarService.complete();
          if (this.view === "avaliable_inventorty") {
            this.slimLoadingBarService.complete();
            this.disableLoading();
          }
        },
      );
  }

  getDuesPaymentWithSharingReport(is_export?) {
    this.slimLoadingBarService.start();
    if (is_export) {
      this.downloading_export = 1;
      this.filter_form.is_export = 1;
    } else {
      this.enableLoading();
    }
    this.ceoReportsService
      .getDuesPaymentWithSharing(this.filter_form)
      .subscribe(
        (res: any) => {
          this.reports.dues_payment_with_sharing.data = res.projects;
          this.reports.dues_payment_with_sharing.total = res;
        },
        (err) => {
          this.errorHandlerService.handleErorr(err);
        },
        () => {
          this.slimLoadingBarService.complete();
          if (this.view === "dues_payment_with_sharing") {
            this.disableLoading();
          }
        },
      );
  }

  getDuesInventoryReport(is_export?) {
    this.slimLoadingBarService.start();
    if (is_export) {
      this.downloading_export = 1;
      this.filter_form.is_export = 1;
    } else {
      this.enableLoading();
    }
    this.ceoReportsService.getDuesInventoryReport(this.filter_form).subscribe(
      (res: any) => {
        if (is_export) {
          window.open(res.url);
          this.downloading_export = false;
          this.filter_form.is_export = false;
          delete this.filter_form.type;
        } else {
          this.reports.dues_inventorty.data = res.projects;
          this.reports.dues_inventorty.total = res.total_amount;
        }
      },
      (err) => {
        this.downloading_export = false;
        this.errorHandlerService.handleErorr(err);
      },
      () => {
        this.slimLoadingBarService.complete();
        if (this.view === "dues_inventorty") {
          this.slimLoadingBarService.complete();
          this.disableLoading();
        }
      },
    );
  }

  getNotAvaliableInventortyReport(is_export?) {
    if (is_export) {
      this.downloading_export = 1;
      this.filter_form.is_export = 1;
    } else {
      this.enableLoading();
    }
    this.ceoReportsService
      .getNotAvaliableInventortyReport(this.filter_form)
      .subscribe(
        (res: any) => {
          if (is_export) {
            window.open(res.url);
            this.downloading_export = false;
            this.filter_form.is_export = false;
            delete this.filter_form.type;
          } else {
            this.reports.not_avaliable_inventorty.data = res.data;
            this.reports.not_avaliable_inventorty.total = res.total;
            console.log(this.reports.not_avaliable_inventorty);
          }
        },
        (err) => {
          this.downloading_export = false;
          this.errorHandlerService.handleErorr(err);
        },
        () => {
          this.slimLoadingBarService.complete();
          if (this.view === "not_avaliable_inventorty") {
            this.disableLoading();
          }
        },
      );
  }


    getMonthlyPaymentsReport(is_export?) {
      if (is_export) {
        this.downloading_export = 1;
        this.filter_form.is_export = 1;
      } else {
        this.enableLoading();
      }
      this.financialReportsService
        .getMonthlyPaymentsReport(this.filter_form)
        .subscribe(
          (res: any) => {
            if (is_export) {
              window.open(res.url);
              this.downloading_export = false;
              this.filter_form.is_export = false;
              delete this.filter_form.type;
            } else {
              this.reports.monthly_payments_analysis_total = res.total_for_total;
              res = Object.entries(res).map(([key, value]) => {
                if (key == "total_for_total") return;
                let data = [];
                Object.entries(value).map(([key2, value2]) => {
                  data.push({ value: value2 });
                });
                return {
                  year: key,
                  data: data,
                };
              });
              this.reports.monthly_payments_analysis = res;
              this.reports.monthly_payments_analysis = removeNullishFieldsParams(
                this.reports.monthly_payments_analysis
              );
              console.log(this.reports.monthly_payments_analysis);
              console.log(this.monthsArray);
            }
          },
          (err) => {
            this.downloading_export = false;
            console.log(err);
          },
          () => {
            if (this.view === "monthly_payments_analysis") {
              this.disableLoading();
            }
          }
        );
    }
    getPartnerMonthlyPaymentsReport(is_export?) {
      if (is_export) {
        this.downloading_export = 1;
        this.filter_form.is_export = 1;
      } else {
        this.enableLoading();
      }
      this.financialReportsService
        .getPartnerMonthlyPaymentsReport(this.filter_form)
        .subscribe(
          (res: any) => {
            if (is_export) {
              window.open(res.url);
              this.downloading_export = false;
              this.filter_form.is_export = false;
              delete this.filter_form.type;
            } else {
              this.reports.partner_monthly_payments_analysis_total =
                res.total_for_total;
              res = Object.entries(res).map(([key, value]) => {
                if (key == "total_for_total") return;
                let data = [];
                Object.entries(value).map(([key2, value2]) => {
                  data.push({ value: value2 });
                });
                return {
                  year: key,
                  data: data,
                };
              });
              this.reports.partner_monthly_payments_analysis = res;
              console.log(this.reports.partner_monthly_payments_analysis);
              console.log(this.monthsArray);
            }
          },
          (err) => {
            this.downloading_export = false;
            console.log(err);
          },
          () => {
            if (this.view === "partner_monthly_payments_analysis") {
              this.disableLoading();
            }
          }
        );
    }

  // loading alg
  loading_texts = [
    "Initiating Report",
    "Calculate Data",
    "Grouping Results",
    "Loading",
  ];

  loader = {
    index: 0,
    dot: 0,
    maxDot: 3,
    text: this.loading_texts[0],
    interval: null,
  };
  enableLoading() {
    this.isLoading = true;

    this.loader.index = 0;
    this.loader.dot = 0;
    this.loader.text = this.loading_texts[0];

    this.loader.interval = setInterval(() => {
      if (!this.isLoading) return this.disableLoading();

      if (this.loader.dot < this.loader.maxDot) {
        this.loader.dot++;
        this.loader.text += ".";
      } else {
        this.loader.dot = 0;
        if (this.loader.index < this.loading_texts.length - 1) {
          this.loader.index++;
        } else {
          this.loader.index = 0;
        }
        this.loader.text = this.loading_texts[this.loader.index];
      }
    }, 1000);
  }

  disableLoading() {
    this.isLoading = false;
    clearInterval(this.loader.interval);
  }

  downloadReport(sub_type?) {
    switch (this.view) {
      case "sold_inventorty": {
        this.getSoldInventortyReport(1);
        break;
      }
      case "avaliable_inventorty": {
        this.getAvaliableInventortyReport(1);
        break;
      }
      case "dues_payment_with_sharing": {
        this.getDuesPaymentWithSharingReport(1);
        break;
      }
      case "dues_inventorty": {
        this.getDuesInventoryReport(1);
        break;
      }
      case "not_avaliable_inventorty": {
        this.getNotAvaliableInventortyReport(1);
        break;
      }
      case "monthly_payments_analysis": {
        this.getMonthlyPaymentsReport(1);
        break;
      }
      case "partner_monthly_payments_analysis": {
        this.getPartnerMonthlyPaymentsReport(1);
        break;
      }
    }
  }

  // singleReportDownloadCombinedStatemenet(row) {
  //   console.log(row);
  //   this.ceoReportsService
  //     .downloadReportCombinedStatementAccount(row.id)
  //     .subscribe((res: any) => {
  //       window.open(res);
  //     });
  // }
}



// WEBPACK FOOTER //
// ./src/app/ceo-reports/ceo-reports.component.ts